import React from "react";
import {
  ControlledMenu,
  MenuItem,
  MenuState,
  MenuDivider,
} from "@szhsin/react-menu";
import styled, { keyframes } from "styled-components";
import {
  menuSelector,
  menuItemSelector,
  menuDividerSelector,
} from "@szhsin/react-menu/style-utils";
import {
  BsDownload as DownloadIcon,
  BsChat as ChatIcon,
  BsArrowsAngleExpand as ExpandIcon,
} from "react-icons/bs";
import { FiAlertTriangle as DataAlertIcon } from "react-icons/fi";
import { useAppSelector } from "../../../../../../../redux/reduxHooks";
import { VscPinned as PinIcon } from "react-icons/vsc";
import UnpinIcon from "../../../../../../../assets/images/UnPinIcon.svg";
import styles from "./dataPieceMenu.module.scss";
import { MdLockOutline } from "react-icons/md";
import {
  GASendEvent,
  getLocalUser,
} from "../../../../../../../components/functions/utilities";
import {
  DatapieceType,
  GADimensions,
  GAEvents,
} from "../../../../../../../interfaces/interfaces";

type Props = {
  menuProps: {
    state?: MenuState;
    endTransition: () => void;
  };
  isChart: boolean;
  downloadDataPieceLoading?: boolean;
  anchorPoint: { x: number; y: number };
  toggleMenu: (menuState: boolean) => void;
  dataPieceIdentifier: string;
  createNewTrend: () => void;
  createNewChat: () => void;
  createNewAlert: () => void;
  downloadDataPiece: () => void;
  openEditAccess: () => void;
  enableRename: () => void;
  chartType?: string;
  isDemoDp?: boolean;
  isDashboard?: boolean;
  isMenuOpen: boolean;
  pinnedToDashboard?: boolean;
  togglePinDashboard?: (value: boolean) => void;
  isConsolidated?: boolean;
  report?: any;
  datapiece: {
    title: string;
    type: DatapieceType;
  };
};

const menuShow = keyframes`
  from {
    opacity: 0;
  }
`;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
`;

export const CustomMenu = styled(ControlledMenu)`
  ${menuSelector.name} {
    font-size: 0.8rem;
    user-select: none;
    box-shadow: 1px 1px 20px 1px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    /* padding: 6px; */
    min-width: 18rem;
    max-width: 18rem;
    z-index: 101;
  }

  ${menuDividerSelector.name} {
    background-color: #d1d1d1;
  }

  ${menuItemSelector.name} {
    display: flex;
    align-items: "center";
    gap: 1rem;
    padding: 0.3rem 1.2rem;
    color: #808080;
  }

  ${menuItemSelector.disabled} {
    opacity: 0.5;
  }

  ${menuItemSelector.hover} {
    background-color: #fff;
  }

  ${menuSelector.stateOpening} {
    animation: ${menuShow} 0.15s ease-out;
  }
`;

export const IconContainer = styled.div`
  font-size: 1rem;
`;

const DataPieceMenu = React.forwardRef(
  (
    {
      chartType = "",
      menuProps,
      anchorPoint,
      toggleMenu,
      dataPieceIdentifier,
      createNewAlert,
      createNewChat,
      downloadDataPieceLoading,
      downloadDataPiece,
      openEditAccess,
      createNewTrend,
      enableRename,
      isChart,
      isDemoDp = false,
      isMenuOpen,
      isDashboard = false,
      pinnedToDashboard = false,
      togglePinDashboard = () => {},
      isConsolidated = false,
      report = {},
      datapiece,
    }: Props,
    ref: any
  ) => {
    const { workspaceTourRunState, currentWorkspaceStepValue } = useAppSelector(
      (state) => state.tutorials
    );

    return (
      <CustomMenu
        // {...menuProps}
        state={isMenuOpen ? "open" : "closed"}
        anchorRef={ref}
        // anchorPoint={anchorPoint}
        onClose={() => {
          //
          if (workspaceTourRunState) return;
          toggleMenu(false);
        }}
      >
        <div className={`${isDemoDp ? "demo_menu" : ""}`}>
          {isChart || (isDemoDp && currentWorkspaceStepValue !== null) ? (
            <>
              <MenuItem
                disabled={
                  true
                  // currentWorkspaceStepValue
                  //   ? false
                  //   : !dataPieceIdentifier.includes("trend") &&
                  //     !dataPieceIdentifier.includes("table") &&
                  //     !(chartType == "scatter") &&
                  //     isConsolidated
                  //   ? false
                  //   : true
                }
                onClick={({ syntheticEvent, stopPropagation }) => {
                  syntheticEvent.stopPropagation();
                  stopPropagation = true;
                  createNewAlert();
                }}
                className={`${isDemoDp ? "demo_data_alert_menu" : ""}`}
              >
                <div className={styles.disabledMenuItem}>
                  <div>
                    <IconContainer>
                      <DataAlertIcon />
                    </IconContainer>
                    <div>Create an Alert</div>
                  </div>
                  <MdLockOutline className={styles.lockIcon} />
                </div>
                {/* <IconContainer>
                  <DataAlertIcon />
                </IconContainer>
                <div>Create an Alert</div> */}
              </MenuItem>
              <MenuDivider />
            </>
          ) : null}
          {!isDashboard && (
            <>
              <MenuItem
                disabled={true}
                onClick={({ syntheticEvent, stopPropagation }) => {
                  syntheticEvent.stopPropagation();
                  stopPropagation = true;
                  createNewChat();
                }}
              >
                <div className={styles.disabledMenuItem}>
                  <div>
                    <IconContainer>
                      <ChatIcon />
                    </IconContainer>
                    <div>Create Chat</div>
                  </div>
                  <MdLockOutline className={styles.lockIcon} />
                </div>
                {/* <IconContainer>
                  <ChatIcon />
                </IconContainer>
                <div>Create Chat</div> */}
              </MenuItem>
              <MenuDivider />
            </>
          )}
          {isDashboard ? (
            <>
              <MenuItem
                onClick={({ syntheticEvent, stopPropagation }) => {
                  syntheticEvent.stopPropagation();
                  stopPropagation = true;
                  togglePinDashboard(!pinnedToDashboard);
                }}
              >
                <IconContainer>
                  {pinnedToDashboard ? (
                    <img
                      style={{ paddingLeft: "0.2rem", width: "0.9rem" }}
                      src={UnpinIcon}
                    />
                  ) : (
                    <PinIcon />
                  )}
                </IconContainer>
                <div>
                  {!pinnedToDashboard
                    ? "Pin to Dashboard"
                    : "Unpin from Dashboard"}
                </div>
              </MenuItem>
              <MenuDivider />
            </>
          ) : null}
          <MenuItem
            onClick={({ syntheticEvent, stopPropagation }) => {
              syntheticEvent.stopPropagation();
              stopPropagation = true;
              // DOWNLOAD EXCEL
              try {
                // console.log(import.meta.env.VITE_MERITO_COMPANY_ID.split(","));
                // console.log(
                //   report?.reportName
                //     ? report?.reportName
                //     : report?.initialReportName
                // );
                // console.log(
                //   !import.meta.env.VITE_MERITO_COMPANY_ID.includes(
                //     String(user?.companyId)
                //   )
                // );
                // if (user?.companyId != import.meta.env.VITE_MERITO_COMPANY_ID && import.meta.env.TRACK_GA == 'YES') {
                // ReactGA.pageview("/" + path);
                // console.log(dataPieceIdentifier);
                const user = getLocalUser();
                if (
                  [DatapieceType.cohort, DatapieceType.pivotTable].includes(
                    datapiece.type
                  )
                ) {
                  const dimension = {
                    [GADimensions.userType]: user?.role,
                    [GADimensions.companyId]: user?.companyId,
                    [GADimensions.companyName]: user?.companyName,
                    [GADimensions.workspaceName]: report?.initialReportName,
                    [GADimensions.userLoginId]: user?.id,
                    [GADimensions.userName]: user?.name,
                    [GADimensions.datapieceName]: datapiece.title,
                    [GADimensions.datapieceType]: datapiece.type,
                    [GADimensions.datapieceIdentifier]: dataPieceIdentifier,
                  };
                  GASendEvent(user, GAEvents.download_as_excel, dimension);
                }
              } catch {
                console.log("error in tracking");
              }
              downloadDataPiece();
            }}
          >
            <IconContainer>
              <DownloadIcon />
            </IconContainer>
            <div>Download</div>
          </MenuItem>
          {/* {!isDashboard && <MenuDivider />} */}

          {/* <MenuItem disabled={!dataPieceIdentifier.includes('trend') && !(chartType == 'scatter') ? false : true} onClick={createNewTrend}>
                    <IconContainer>
                        <img src={TrendIcon} alt="" />
                    </IconContainer>
                    <div>
                        Trend Analysis
                    </div>
                </MenuItem>
                <MenuDivider /> */}
          {/* 
          {!isDashboard ? (
            <>
              <MenuItem
                onClick={({ syntheticEvent, stopPropagation }) => {
                  syntheticEvent.stopPropagation();
                  stopPropagation = true;
                  openEditAccess();
                }}
              >
                <IconContainer>
                  <EditAccessIcon />
                </IconContainer>
                <div>Edit access</div>
              </MenuItem>
            </>
          ) : null} */}
          {/* {!isDashboard ? (
            // <>
            //   <MenuItem
            //     onClick={({ syntheticEvent, stopPropagation }) => {
            //       syntheticEvent.stopPropagation();
            //       stopPropagation = true;
            //       enableRename();
            //     }}
            //   >
            //     <IconContainer>
            //       <RenameIcon />
            //     </IconContainer>
            //     <div>Rename</div>
            //   </MenuItem>
            // </>
          // ) : null} */}
        </div>
      </CustomMenu>
    );
  }
);

export default DataPieceMenu;
